var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_61_1562)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 6H3C2.4485 6 2 6.4485 2 7V8C2 8.5515 2.4485 9 3 9H4C4.5515 9 5 8.5515 5 8V7C5 6.4485 4.5515 6 4 6ZM3 8V7H4V8H3ZM9.5 1H9V0.5C9 0.224 8.7765 0 8.5 0C8.2235 0 8 0.224 8 0.5V1H4V0.5C4 0.224 3.7765 0 3.5 0C3.2235 0 3 0.224 3 0.5V1H2.5C1.1215 1 0 2.1215 0 3.5V9.5C0 10.8785 1.1215 12 2.5 12H9.5C10.8785 12 12 10.8785 12 9.5V3.5C12 2.1215 10.8785 1 9.5 1ZM2.5 2H9.5C10.327 2 11 2.673 11 3.5V4H1V3.5C1 2.673 1.673 2 2.5 2ZM9.5 11H2.5C1.673 11 1 10.327 1 9.5V5H11V9.5C11 10.327 10.327 11 9.5 11Z",
    fill: "#707C97"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_61_1562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarDay);
export default __webpack_public_path__ + "static/media/calendar-day.c7bd3efceefa5347d84300aaeb8ee024.svg";
export { ForwardRef as ReactComponent };